import React from 'react';
import { Tooltip, Tooltiptext } from '@flexisaf/flexibull2';
import { darken, transparentize } from 'polished';
import styled, { css } from 'styled-components';
import Theme from 'utils/theme';
import PropTypes from 'prop-types';

const SideModalWrapper = styled.div`
  width: 100%;
  max-width: ${(props) => props.fullScreen ? '100vw' : '1000px' };
  top: 0;
  right: 0;
  position: fixed;
  background: #fff;
  height: 100vh;
  z-index: 1000;
  box-shadow: -5px 0 35px rgba(0, 0, 0, 0.2);
  border-left: 1px solid ${(props) => darken(0.1, props.theme.PrimaryFade)};
  display: none;

  ${(props) =>
    props.open &&
    css`
      display: block;
    `}
  & .side-container {
    width: inherit;
    height: 100vh;
    display: grid;
    grid-template-columns: 1fr 1fr 1fr;
    grid-template-rows: max-content max-content auto;
    overflow-y: auto;

    & .applicant-info {
      background: ${(props) => props.theme.PrimaryFade};
      grid-row: 1;
      grid-column: 1 / 4;
      padding: 24px;
      position: sticky;
      z-index: 3;
      top: 0;

      display: grid;
      grid-template-columns: auto max-content;
      grid-gap: 24px;

      & .applicant-info-actions {
        grid-row: 1;
        grid-column: 2;
        &.flex-div {
          display: flex;
          & > div {
            margin: 4px;
          }
        }
        @media (max-width: 1000px) {
          padding-right: 50px;
          &.flex-div {
            display: block;
            text-align: right;
          }
        }
      }
      & .applicant-info-details {
        grid-row: 1;
        grid-column: 1;
      }
    }
    & .applicant-info-loader {
      grid-column: 1 / 4;
      & .contento {
        min-height: 200vh;
      }
    }
    & .applicant-detail {
      background: ${(props) => props.theme.PrimaryFade};
      min-height: 200px;
      grid-row: 2;
      grid-column: 1 / 4;
      padding: 24px;
      display: grid;
      grid-template-columns: auto max-content;
      grid-gap: 24px;

      & .applicant-detail-info {
        grid-row: 1;
        grid-column: 1;
        & > div {
          margin-bottom: 8px;
        }
        & .flexi-tag {
          margin: 4px;
        }
      }
      & .applicant-detail-photo {
        grid-row: 1;
        grid-column: 2;
        & .applicant-detail-photo-container {
          display: inline-block;
          padding: 8px;
          border: 1px solid ${(props) => props.theme.PrimaryBorderColor};
          border-radius: ${(props) => props.theme.PrimaryRadius};
          & img {
            border-radius: ${(props) => props.theme.PrimaryRadius};
            width: 150px;
          }
        }
      }
    }
    & .application-detail-loader {
      grid-column: 1 / 4;
      & .contento {
        min-height: 200vh;
      }
    }
    & .application-detail {
      background: #fff;
      grid-row: 3;
      grid-column: 1 / 4;
      & .contento {
        min-height: 200vh;
      }
    }

    & .show-on-mini {
      display: none;
    }
  }

  & .sideControl {
    position: absolute;
    right: 100%;
    padding: 8px;
    border: 1px solid ${(props) => darken(0.1, props.theme.PrimaryFade)};
    background: #fff;
    border-top: none;
    border-right: 0;
    box-shadow: -5px 0 35px rgba(0, 0, 0, 0.1);
    border-radius: 0 0 0 ${(props) => props.theme.SecondaryRadius};
    z-index: 5;

    @media (max-width: 1000px) {
      top: 0;
      right: 0;
      display: flex;

      & .applicant-resizer {
        display: none;
      }
    }
  }
  @media (min-width: 1000px) {
    ${(props) =>
      props.maximized &&
      css`
        max-width: calc(100vw - 10px - ${Theme.SideNavOpen});

        & .side-container {
          grid-template-columns: 350px auto;
          grid-template-rows: max-content auto;
          overflow: hidden;
          background: ${(props) => props.theme.PrimaryFade};

          & .applicant-info {
            grid-column: 1;
            grid-row: 1;
            position: relative;

            & .applicant-info-actions {
              grid-row: 1;
              grid-column: 1;
            }
            & .applicant-info-details {
              grid-row: 2/3;
              grid-column: 1;
            }
          }
          & .applicant-info-loader {
            grid-column: 1;
            grid-row: 1 /4;
            grid-template-columns: max-content;
            position: relative;
            background: #fff;
            align-items: stretch;
          }
          & .applicant-detail {
            grid-column: 1;
            grid-row: 2 / 3;
            display: grid;
            grid-template-columns: 1fr;
            grid-template-rows: max-content auto;
            padding-top: 0;

            & .applicant-detail-info {
              grid-row: 2;
              grid-column: 1;
            }
            & .applicant-detail-photo {
              grid-row: 1;
              grid-column: 1;

              & .applicant-detail-photo-container {
                & img {
                  width: 120px;
                }
              }
            }
          }
          & .application-detail {
            grid-column: 2;
            grid-row: 1 / 4;
            height: 100vh;
            overflow-y: auto;
            background: #fff;
          }

          & .show-on-mini {
            display: block;
          }
        }
      `}
  }
  & .applicant-infox {
    max-width: 900px;
    border: 1px solid ${(props) => props.theme.PrimaryBorderColor};
    border-radius: ${(props) => props.theme.SecondaryRadius};
    margin: 24px;

    & .applicant-infox-row {
      padding: 20px;
      border-bottom: 1px solid ${(props) => props.theme.PrimaryBorderColor};
      &:last-child {
        border-bottom: 0;
      }
      &:nth-child(even) {
        background: ${(props) => transparentize(0.4, props.theme.PrimaryFade)};
      }
      & .applicant-infox-row-header {
        margin-bottom: 20px;
      }
    }
  }
`;

const FullScreenSideModalWrapper = styled.div`
  width: 100%;
  max-width: 100vw;
  top: 0;
  right: 0;
  position: fixed;
  background: #fff;
  height: 100vh;
  z-index: 1000;
  box-shadow: -5px 0 35px rgba(0, 0, 0, 0.2);
  border-left: 1px solid ${(props) => darken(0.1, props.theme.PrimaryFade)};
  display: block;

  & .side-container {
    width: inherit;
    height: 100vh;
    display: grid;
    grid-template-columns: 1fr 1fr 1fr;
    grid-template-rows: max-content max-content auto;
    overflow-y: auto;

    & .applicant-info {
      background: ${(props) => props.theme.PrimaryFade};
      grid-row: 1;
      grid-column: 1 / 4;
      padding: 24px;
      position: sticky;
      z-index: 3;
      top: 0;

      display: grid;
      grid-template-columns: auto max-content;
      grid-gap: 24px;

      & .applicant-info-actions {
        grid-row: 1;
        grid-column: 2;
        &.flex-div {
          display: flex;
          & > div {
            margin: 4px;
          }
        }
        @media (max-width: 1000px) {
          padding-right: 50px;
          &.flex-div {
            display: block;
            text-align: right;
          }
        }
      }
      & .applicant-info-details {
        grid-row: 1;
        grid-column: 1;
      }
    }
    & .applicant-info-loader {
      grid-column: 1 / 4;
      & .contento {
        min-height: 200vh;
      }
    }
    & .applicant-detail {
      background: ${(props) => props.theme.PrimaryFade};
      min-height: 200px;
      grid-row: 2;
      grid-column: 1 / 4;
      padding: 24px;
      display: grid;
      grid-template-columns: auto max-content;
      grid-gap: 24px;

      & .applicant-detail-info {
        grid-row: 1;
        grid-column: 1;
        & > div {
          margin-bottom: 8px;
        }
        & .flexi-tag {
          margin: 4px;
        }
      }
      & .applicant-detail-photo {
        grid-row: 1;
        grid-column: 2;
        & .applicant-detail-photo-container {
          display: inline-block;
          padding: 8px;
          border: 1px solid ${(props) => props.theme.PrimaryBorderColor};
          border-radius: ${(props) => props.theme.PrimaryRadius};
          & img {
            border-radius: ${(props) => props.theme.PrimaryRadius};
            width: 150px;
          }
        }
      }
    }
    & .application-detail-loader {
      grid-column: 1 / 4;
      & .contento {
        min-height: 200vh;
      }
    }
    & .application-detail {
      background: #fff;
      grid-row: 3;
      grid-column: 1 / 4;
      & .contento {
        min-height: 200vh;
      }
    }

    & .show-on-mini {
      display: none;
    }
  }

  & .sideControl {
    position: absolute;
    right: 100%;
    padding: 8px;
    border: 1px solid ${(props) => darken(0.1, props.theme.PrimaryFade)};
    background: #fff;
    border-top: none;
    border-right: 0;
    box-shadow: -5px 0 35px rgba(0, 0, 0, 0.1);
    border-radius: 0 0 0 ${(props) => props.theme.SecondaryRadius};
    z-index: 5;

    @media (max-width: 1000px) {
      top: 0;
      right: 0;
      display: flex;

      & .applicant-resizer {
        display: none;
      }
    }
  }
  @media (min-width: 1000px) {
    ${(props) =>
      props.maximized &&
      css`
        max-width: 100vw;

        & .side-container {
          grid-template-columns: 350px auto;
          grid-template-rows: max-content auto;
          overflow: hidden;
          background: ${(props) => props.theme.PrimaryFade};

          & .applicant-info {
            grid-column: 1;
            grid-row: 1;
            position: relative;

            & .applicant-info-actions {
              grid-row: 1;
              grid-column: 1;
            }
            & .applicant-info-details {
              grid-row: 2/3;
              grid-column: 1;
            }
          }
          & .applicant-info-loader {
            grid-column: 1;
            grid-row: 1 /4;
            grid-template-columns: max-content;
            position: relative;
            background: #fff;
            align-items: stretch;
          }
          & .applicant-detail {
            grid-column: 1;
            grid-row: 2 / 3;
            display: grid;
            grid-template-columns: 1fr;
            grid-template-rows: max-content auto;
            padding-top: 0;

            & .applicant-detail-info {
              grid-row: 2;
              grid-column: 1;
            }
            & .applicant-detail-photo {
              grid-row: 1;
              grid-column: 1;

              & .applicant-detail-photo-container {
                & img {
                  width: 120px;
                }
              }
            }
          }
          & .application-detail {
            grid-column: 2;
            grid-row: 1 / 4;
            height: 100vh;
            overflow-y: auto;
            background: #fff;
          }

          & .show-on-mini {
            display: block;
          }
        }
      `}
  }
  & .applicant-infox {
    max-width: 900px;
    border: 1px solid ${(props) => props.theme.PrimaryBorderColor};
    border-radius: ${(props) => props.theme.SecondaryRadius};
    margin: 24px;

    & .applicant-infox-row {
      padding: 20px;
      border-bottom: 1px solid ${(props) => props.theme.PrimaryBorderColor};
      &:last-child {
        border-bottom: 0;
      }
      &:nth-child(even) {
        background: ${(props) => transparentize(0.4, props.theme.PrimaryFade)};
      }
      & .applicant-infox-row-header {
        margin-bottom: 20px;
      }
    }
  }
`;

const WindowButtons = styled.div`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 32px;
  height: 32px;
  border-radius: 50%;
  margin: 8px;
  background: ${(props) => props?.color};
  color: #fff;
  cursor: pointer;

  &:hover {
    background: ${(props) => props.color && darken(0.2, props.color)};
  }
`;

export const SideModal = (props) => {
  const { children, onClose, max, setMax } = props;

  return (
    <SideModalWrapper {...props} maximized={max}>
      <div className="sideControl">
        <Tooltip>
          <WindowButtons color={Theme.PrimaryRed} onClick={onClose}>
            <i className="saf-cancel" />
          </WindowButtons>
          <Tooltiptext>Close Window</Tooltiptext>
        </Tooltip>
        <Tooltip className="applicant-resizer">
          <WindowButtons color={Theme.PrimaryGreen} onClick={() => setMax()}>
            <i className="saf-resize-full" />
          </WindowButtons>
          <Tooltiptext>{max ? 'Minimize View' : 'Maximize View'}</Tooltiptext>
        </Tooltip>
      </div>
      {children}
    </SideModalWrapper>
  );
};

SideModal.propTypes = {
  onClose: PropTypes.func,
  children: PropTypes.any,
  max: PropTypes.bool,
  setMax: PropTypes.func,
};

export const SideModalFullScreen = (props) => {
  const { children } = props;

  return (
    <FullScreenSideModalWrapper {...props} maximized={true}>
      {children}
    </FullScreenSideModalWrapper>
  );
};

SideModalFullScreen.propTypes = {
  children: PropTypes.any,
  max: PropTypes.bool,
};
